module.exports = __webpack_public_path__ + "static/media/icon_48.a56f2e06.svg";